import './StatCard.css';

/**
 * StatCard component for dashboard metrics
 * @param {string} label - Stat label
 * @param {string|number} value - Stat value
 * @param {string} change - Change percentage (e.g., "+12%")
 * @param {string} changeType - "positive", "negative", "warning", "neutral"
 * @param {boolean} loading - Show loading skeleton
 */
const StatCard = ({ label, value, change, changeType = 'positive', className = '', loading = false }) => {
  return (
    <div className={`stat-card ${loading ? 'loading' : ''} ${className}`}>
      <div className="stat-label">{label}</div>
      {loading ? (
        <>
          <div className="stat-value-skeleton"></div>
          <div className="stat-change-skeleton"></div>
        </>
      ) : (
        <>
          <div className="stat-value">{value}</div>
          {change && changeType !== 'neutral' && (
            <div className={`stat-change ${changeType}`}>
              {changeType === 'positive' && '↑'}
              {changeType === 'negative' && '↓'}
              {changeType === 'warning' && '~'}
              {' '}{change}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StatCard;
